/**
 * Guided tour for the RFI detail view (``RfiDetail``).
 *
 * Runs only when the user lands on a detail page *without* having seen
 * the {@link combined.ts | combined tour} (which already covers the
 * same content). Catches direct-URL / late-creation cases.
 */
import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import {
  assignmentStep,
  attachmentsStep,
  commentsStep,
  headerActionsStep,
  metadataStep,
  questionStep,
  responseStep,
} from './steps';

export const RFIS_DETAIL_TOUR_ID = 'rfis.detail';

registerTour({
  id: RFIS_DETAIL_TOUR_ID,
  name: 'RFI',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.RFIS.id,
  steps: [
    {
      id: 'welcome',
      title: 'RFI details',
      body:
        'Here\u2019s everything tied to this RFI — question, response, ' +
        'comments, attachments, and the people responsible.',
    },
    headerActionsStep,
    metadataStep,
    questionStep,
    responseStep,
    commentsStep,
    attachmentsStep,
    assignmentStep,
  ],
});
